// Source https://github.com/google/eleventy-high-performance-blog/blob/main/_11ty/blurry-placeholder.js

const PIXEL_TARGET = 60

const ESCAPE_TABLE = {
    "#": "%23",
    "%": "%25",
    ":": "%3A",
    "<": "%3C",
    ">": "%3E",
    '"': "'"
}
const ESCAPE_REGEX = new RegExp(Object.keys(ESCAPE_TABLE).join("|"), "g")
const escaper = (match: string) => {
    return ESCAPE_TABLE[match as keyof typeof ESCAPE_TABLE]
}

const getBitmapDimensions_ = (imgWidth: number, imgHeight: number) => {
    // Aims for a bitmap of ~P pixels (w * h = ~P).
    // Gets the ratio of the width to the height. (r = w0 / h0 = w / h)
    const ratioWH = imgWidth / imgHeight
    // Express the width in terms of height by multiply the ratio by the
    // height. (h * r = (w / h) * h)
    // Plug this representation of the width into the original equation.
    // (h * r * h = ~P).
    // Divide the bitmap size by the ratio to get the all expressions using
    // height on one side. (h * h = ~P / r)
    let bitmapHeight = PIXEL_TARGET / ratioWH
    // Take the square root of the height instances to find the singular value
    // for the height. (h = sqrt(~P / r))
    bitmapHeight = Math.sqrt(bitmapHeight)
    // Divide the goal total pixel amount by the height to get the width.
    // (w = ~P / h).
    const bitmapWidth = PIXEL_TARGET / bitmapHeight
    return { width: Math.round(bitmapWidth), height: Math.round(bitmapHeight) }
}

// Generate blurry placeholder URL directly during render - appears immediately when CSS is parsed
export function getBlurSVGPlaceholder(lqip: string, width = 20, height = 20) {
    // Remove whitespace from lqip (just in case)
    // Build SVG as a single line
    let svg = `<svg xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 ${getBitmapDimensions_(width, height).width} ${getBitmapDimensions_(width, height).height}">
    <filter id="b" color-interpolation-filters="sRGB">
      <feGaussianBlur stdDeviation=".5"></feGaussianBlur>
      <feComponentTransfer>
        <feFuncA type="discrete" tableValues="1 1"></feFuncA>
      </feComponentTransfer>
    </filter>
    <image filter="url(#b)" preserveAspectRatio="none"
      height="100%" width="100%"
      xlink:href="${lqip}">
    </image>
  </svg>`

    // Optimizes dataURI length by deleting line breaks, and
    // removing unnecessary spaces.
    // Encode the entire SVG ONCE

    svg = svg.replace(/\s+/g, " ")
    svg = svg.replace(/> </g, "><")
    svg = svg.replace(ESCAPE_REGEX, escaper)
    return `data:image/svg+xml;charset=utf-8,${svg}`
}
